export const LOCATION_LIST_ACTION = "LOCATION_LIST_ACTION";
export const LOCATION_LIST_SUCCESS = "LOCATION_LIST_SUCCESS";
export const LOCATION_LIST_FAIL = "LOCATION_LIST_FAIL";
export const LOCATION_DETAIL_ACTION = "LOCATION_DETAIL_ACTION";
export const LOCATION_DETAIL_SUCCESS = "LOCATION_DETAIL_SUCCESS";
export const LOCATION_DETAIL_FAIL = "LOCATION_DETAIL_FAIL";
export const LOCATION_SAVE_SUCCESS = "LOCATION_SAVE_SUCCESS";
export const LOCATION_SAVE_ACTION = "LOCATION_SAVE_ACTION";
export const LOCATION_SAVE_FAIL = "LOCATION_SAVE_FAIL";
export const LOCATION_DELETE_SUCCESS = "LOCATION_DELETE_SUCCESS";
export const LOCATION_DELETE_ACTION = "LOCATION_DELETE_ACTION";
export const LOCATION_DELETE_FAIL = "LOCATION_DELETE_FAIL";